import type { ValidationError, ChapterErrors, ValidationResult } from './types'
import type { PersonenFachklinikLaufzeit } from '@/types/studyTypes'

export function validatePersonenFachklinikLaufzeit(
  d: PersonenFachklinikLaufzeit,
): ValidationError[] {
  const errors: ValidationError[] = []

  // Always required
  if (!d.studientitel?.trim())
    errors.push({ field: 'studientitel', message: 'Studientitel ist ein Pflichtfeld.' })

  // PI sub-fields — all required
  const pi = d.principalInvestigator
  if (!pi?.firstName?.trim())
    errors.push({
      field: 'principalInvestigator.firstName',
      message: 'Vorname des PI ist ein Pflichtfeld.',
    })
  if (!pi?.lastName?.trim())
    errors.push({
      field: 'principalInvestigator.lastName',
      message: 'Nachname des PI ist ein Pflichtfeld.',
    })
  if (!pi?.email?.trim())
    errors.push({
      field: 'principalInvestigator.email',
      message: 'E-Mail des PI ist ein Pflichtfeld.',
    })
  else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(pi.email))
    errors.push({ field: 'principalInvestigator.email', message: 'E-Mail-Adresse ist ungültig.' })
  if (pi?.klinik === undefined || pi?.klinik?.length < 1)
    errors.push({
      field: 'principalInvestigator.klinik',
      message: 'Fachklinik/Einrichtung des PI ist ein Pflichtfeld.',
    })

  const ap = d.ansprechpartner
  if (ap) {
    if (!ap.firstName?.trim())
      errors.push({ field: 'ansprechpartner.firstName', message: 'Vorname ist ein Pflichtfeld.' })
    if (!ap.lastName?.trim())
      errors.push({ field: 'ansprechpartner.lastName', message: 'Nachname ist ein Pflichtfeld.' })
    if (!ap.email?.trim())
      errors.push({ field: 'ansprechpartner.email', message: 'E-Mail ist ein Pflichtfeld.' })
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(ap.email))
      errors.push({ field: 'ansprechpartner.email', message: 'E-Mail-Adresse ist ungültig.' })
    if (ap.klinik === undefined || ap.klinik?.length < 1)
      errors.push({ field: 'ansprechpartner.klinik', message: 'Fachklinik/Einrichtung des Ansprechpartners ist ein Pflichtfeld.' })
  }

  // laufzeit — match the actual model field names
  if (!d.laufzeit?.startDate)
    errors.push({ field: 'laufzeit.startDate', message: 'Startdatum ist ein Pflichtfeld.' })

  if (!d.ohneEnddatum && !d.laufzeit?.endDate)
    errors.push({
      field: 'laufzeit.endDate',
      message: 'Enddatum ist erforderlich, oder „ohne Enddatum" wählen.',
    })

  if (d.laufzeit?.startDate && d.laufzeit?.endDate) {
    const start = new Date(d.laufzeit.startDate)
    const end = new Date(d.laufzeit.endDate)
    if (end <= start)
      errors.push({
        field: 'laufzeit.endDate',
        message: 'Enddatum muss nach dem Startdatum liegen.',
      })
  }

  return errors
}
